import classNames from "classnames";
import { MouseEventHandler, ReactNode } from "react";
import "./Button.scss";

const Button = ({
	children,
	onClick,
	className,
	disabled,
	...props
}: {
	children?: ReactNode;
	onClick: MouseEventHandler<HTMLButtonElement>;
	disabled?: boolean;
	className?: string;
}) => {
	return (
		<button
			onClick={onClick}
			className={classNames("button", className)}
			disabled={disabled}
			{...props}>
			{children}
		</button>
	);
};

export default Button;
